const websiteConfig = {
    basic: { // 官网基础信息
        gameId: 331,
        packageName: '', // 配置微端端包名
        websiteId: 'pcofficial',
        title: 'Primal Conquest: Dino Era',
        description: '',
        keywords: 'Survive, thrive, conquer! Take charge of a paleolithic tribe, ensure their survival in a hostile world, and lead them to glory in Primal Conquest: Dino Era!',
        review: true, // 是否审核模式，如果为true时，只有满足链接store=1时才会展示第三方储值相关
    },
    // 官网模块内容及顺序
    section: [
        'index', // 首屏
        // 'video', // 视频
        'news', // 新闻资讯
        // 'thirdParty', // 社群
        'role', // 角色
        'special' // 特色
    ],
    menu: {
        list: [
            // 导航栏配置：
            // name:显示名称
            // type: scroll: 滚动、 routeName：切换路由、link：链接外跳
            // target: 滚动的dom选择器或跳转链接
            // review: 是否判断审核状态，默认false
            {
                name: 'home',
                type: 'scroll',
                target: '#index',
            },
            {
                name: 'news',
                type: 'routeName',
                target: 'List',
            },
            // {
            //     name: 'community',
            //     type: 'scroll',
            //     target: '#thirdParty',
            // },
            {
                name: 'character',
                type: 'scroll',
                target: '#role',
            },
            {
                name: 'features',
                type: 'scroll',
                target: '#special',
            },
            {
                name: 'topUp',
                type: 'link',
                target: '//pay.37games.com/platform/officialWebStore.html?gameId=331&cid=official&scid=btn',
                review: true,
            },
            {
                name: 'customerService',
                type: 'link',
                target: '//gabres.37games.com/platform/officialSupport.html?gameId=331&Isdblink=0&advertiser=global#/creatework?source=orderlist',
            },
        ],
        safeDistance: 70, // 滚动安全区，单位px
        logo: new URL('@images/logo.png', import.meta.url),
        thirdParty: [ // 菜单需展示的社群，同时关联PC/移动端导航弹窗，当种类数量大于1个时，会在右侧展示
            {
                type: 'discord',
                link: 'https://discord.gg/JYGrNJ6h6S'
            },
            {
                type: 'facebook',
                link: 'https://www.facebook.com/PrimalConquestDinoEra/'
            }
        ],
    },
    lang: {
        show: true, // 是否有多语言
        list: [ //支持的语言选项
            {
                code: 'en-US',
                name: 'English'
            },
        ],
    },
    downloadLink: { // 下载链接，ios/android/sdk 默认会优先从gameInfo接口读取
        appstore: 'https://apps.apple.com/us/app/primal-conquest-dino-era/id6479678287',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.global.zljslg',
        pcPlay: '',
        apk: 'https://d2ex983vwhbc52.cloudfront.net/exe/2026/02/27/135868/com.global.zljslg.website.apk',
        ldPlayer: '',
        yeshen: '',
        blueStack: '',
        default_qrcode: new URL('@images/list/qrcode.png', import.meta.url),
    },
    index: {  // 首屏相关配置
        videoLink: '',
        bgm: '', // 背景音乐
        // slogan: 'slogan',
        showMoreDownload: false,
    },
    videoLink: {
        'en-US': '',
    }, // 视频资讯
    news: {  // 新闻资讯/文章列表配置
        defaultNewsPic: new URL('@images/news/news_article_preview.jpg', import.meta.url), // 新闻默认图片
        type: {
            'en-US': {
                '1933': 'ANNOUNCEMENT',
                '1934': 'EVENT',
                '1932': 'GUIDE'
            },
        }
    },
    thirdParty: {   // 社群相关配置
        supportArr: [ // 支持的社群列表
            {
                type: 'discord',
                link: 'https://discord.gg/UgBqSKv7a2'
            },
        ],
        iframe: { // 只支持facebook/twitter
            type: '', // 显示的社群主页插件
            link: '',
            appId: '',
        },
    },
    role: {  // 角色相关配置
        mainTitle: 'roleMainTitle', // 主标题
        subTitle: 'roleSubTitle', // 副标题
        swiperType: 'normal', // full全屏 / normal普通
        langDiffs: true, // 是否包含多语言
        showSkillText: false,
        list: [
            {
                name: 'herosort1', // 主模块名称 英雄分类1
                roleInfo: [
                    {
                        name: 'hero1',
                        desc: 'hero1_text',
                        mediaType: '',
                        url: '',
                        avatar: new URL('@images/role/avatar_1.png', import.meta.url),
                        pic: new URL('@images/role/char_1.png', import.meta.url),
                        skill: []
                    },
                    {
                        name: 'hero2',
                        desc: 'hero2_text',
                        cv: '',
                        mediaType: '',
                        url: '',
                        avatar: new URL('@images/role/avatar_2.png', import.meta.url),
                        pic: new URL('@images/role/char_2.png', import.meta.url),
                        skill: []
                    },
                    {
                        name: 'hero3',
                        desc: 'hero3_text',
                        cv: '',
                        mediaType: '',
                        url: '',
                        avatar: new URL('@images/role/avatar_3.png', import.meta.url),
                        pic: new URL('@images/role/char_3.png', import.meta.url),
                        skill: []
                    },
                    {
                        name: 'hero4',
                        desc: 'hero4_text',
                        cv: '',
                        mediaType: '',
                        url: '',
                        avatar: new URL('@images/role/avatar_4.png', import.meta.url),
                        pic: new URL('@images/role/char_4.png', import.meta.url),
                        skill: []
                    },
                    {
                        name: 'hero5',
                        desc: 'hero5_text',
                        cv: '',
                        mediaType: '',
                        url: '',
                        avatar: new URL('@images/role/avatar_5.png', import.meta.url),
                        pic: new URL('@images/role/char_5.png', import.meta.url),
                        skill: []
                    },
                ]
            },
        ]
    },
    special: [ // 游戏特色相关配置
        {
            name: 'specialMainTitle', // 主模块名称
            list: [
                {
                    pic_default: new URL('@images/special/en/special_en_0.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_0.jpg', import.meta.url),
                },
                {
                    pic_default: new URL('@images/special/en/special_en_1.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_1.jpg', import.meta.url),
                },
                {
                    pic_default: new URL('@images/special/en/special_en_2.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_2.jpg', import.meta.url),
                },
                {
                    pic_default: new URL('@images/special/en/special_en_3.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_3.jpg', import.meta.url),
                },
                {
                    pic_default: new URL('@images/special/en/special_en_4.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_4.jpg', import.meta.url),
                },
                {
                    pic_default: new URL('@images/special/en/special_en_5.jpg', import.meta.url),
                    pic_US: new URL('@images/special/en/special_en_5.jpg', import.meta.url),
                },
            ]
        },
    ],
    footer: {
        ageLimit: {
            show: false, // 是否展示年龄限制相关，若为false，可不填写对象内age及text内容
            age: '18', // -1:不展示  年龄分级：0 6 12 15 18
            text: [
                '*本遊戲內容涉及暴力（武俠動作）、角色穿著凸顯胸、臂之服飾',
                '*本遊戲部分內容需另行支付費用',
                '*請避免沉迷遊戲'
            ]
        },
        termArr: [ // 包含条款 $HOST: 主域名
            {
                name: 'fwtk',
                link: 'https://gpassport.37games.com/center/ServicePrivacy/service',
            },
            {
                name: 'yszc',
                link: 'https://gpassport.37games.com/center/ServicePrivacy/privacy',
            },
        ]
    },
    articleBanner: {
        'en-US': new URL('@images/list/list_banner.jpg', import.meta.url),
    },
    payAside: {
        show: true,
        payLink: 'https://pay.37games.com/platform/officialWebStore.html?gameId=331&cid=official&scid=btn',
        guidePage: '',
        default_bg: new URL('@images/aside/pay_aside_US.png', import.meta.url),
        bg_US: new URL('@images/aside/pay_aside_US.png', import.meta.url),
    }
}
export default websiteConfig